import React, { Fragment } from 'react';
import useAppSelector from 'hooks/useAppSelector';
import { selectUserInfo } from 'modules/me/slice';
import moment from 'moment';

const StudentInformation = () => {
  const userInfo = useAppSelector(selectUserInfo);

  return (
    <article className="text-[16px] md:text-[16px] mb-[50px] grid grid-cols-1 md:grid-cols-2 md:gap-y-[20px]">
      <strong>First Name</strong>
      <span>{userInfo?.firstname}</span>
      <strong className='mt-[20px] md:mt-0'>Last Name</strong>
      <span>{userInfo?.lastname}</span>
      <strong className='mt-[20px] md:mt-0'>Residential Address</strong>
      <span>{userInfo?.licenseAddress}</span>
      <strong className='mt-[20px] md:mt-0'>Birthdate</strong>
      <span>{userInfo?.birthday}</span>
      <strong className='mt-[20px] md:mt-0'>License Number</strong>
      <span>{userInfo?.licenseNumber}</span>
      <strong className='mt-[20px] md:mt-0'>License Card Number</strong>
      <span>{userInfo?.licenseCardNumber}</span>
      <strong className='mt-[20px] md:mt-0'>Expiry Date</strong>
      <span>{moment(userInfo?.licenseExpiry).format('DD-MM-YYYY')}</span>
      <strong className="mt-[20px] md:mt-0 !w-[285px]">License Country of Issue</strong>
      <span>{userInfo?.licenseCountry}</span>
      {userInfo?.passportNumber && (
        <Fragment>
          <strong>Passport Number</strong>
          <span>{userInfo?.passportNumber}</span>
        </Fragment>
      )}
      {userInfo?.passportCountry && (
        <Fragment>
          <strong>Passport Country of Issue</strong>
          <span>{userInfo?.passportCountry}</span>
        </Fragment>
      )}
    </article>
  );
};

export default StudentInformation;
